/**
 * The link forms help pages and release notes use, resolved to app routes:
 *   [Materials](help:events/materials)  → /help/events/materials
 *   [Show me](guide:materials)          → #guide:materials (a button, run by the article)
 *   ![Tab](img/materials-tab.png)       → the bundled image URL
 * Pure: takes the Markdown and the image map, returns Markdown.
 */

export const HELP_LINK_PREFIX = 'help:';
export const GUIDE_LINK_PREFIX = 'guide:';
/** Where a guide link points once rewritten; the article turns it into a button. */
export const GUIDE_HREF_PREFIX = '#guide:';

/**
 * Rewrites `help:` and `guide:` links and relative image paths.
 *
 * @param markdown - The body of a page.
 * @param images - Bundled image URLs keyed by the path the page would write (`img/x.png`, or the same with the page's folder).
 * @returns Markdown with app links and image URLs.
 */
export function rewriteMarkdown(markdown: string, images: ReadonlyMap<string, string>): string {
  return markdown
    .replace(/\]\(help:([^)\s]+)\)/g, (_match, target: string) => `](/help/${target.replace(/^\/+/, '')})`)
    .replace(/\]\(guide:([^)\s]+)\)/g, (_match, id: string) => `](${GUIDE_HREF_PREFIX}${id})`)
    .replace(/!\[([^\]]*)\]\(([^)\s]+)\)/g, (match, alt: string, src: string) => {
      if (/^(https?:)?\/\//.test(src) || src.startsWith('/') || src.startsWith('data:')) return match;
      const url = images.get(src) ?? images.get(src.replace(/^\.\//, ''));
      return url ? `![${alt}](${url})` : match;
    });
}

/** A URL slug from a file name: "2026-09-07-cloud-review-week.md" → "2026-09-07-cloud-review-week". */
export function slugFromFile(path: string): string {
  return (path.split('/').pop() ?? path).replace(/\.md$/, '');
}
